export default class extends Controller {
  static targets = ["optionsTemplate"]

  add(event) {
    event.preventDefault()
    App.Modal.open({
      content: this.optionsTemplateTarget.innerHTML,
      overSlideOut: true
    });
  }

  get assetType() {
    return this.data.get("type")
  }
}



// WEBPACK FOOTER //
// ./app/components/assets/assets/javascript/assets-add-asset-button-controller.js